import { useState, useEffect } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchPublisherData } from "../../api/publisherService";
export var useDuplicateTable = function () {
    var ky = useOkapiKy();
    var _a = useState(null), selectedDuplicatePublisher = _a[0], setSelectedDuplicatePublisher = _a[1];
    var _b = useState(null), selectedDuplicatePublisherId = _b[0], setSelectedDuplicatePublisherId = _b[1];
    var onClose = function () {
        setSelectedDuplicatePublisher(null);
        setSelectedDuplicatePublisherId(null);
    };
    useEffect(function () {
        if (selectedDuplicatePublisherId) {
            fetchPublisherData(selectedDuplicatePublisherId, ky)
                .then(function (publisher) {
                setSelectedDuplicatePublisher(publisher);
            })
                .catch(function (error) {
                console.error("Error fetching duplicate publisher data:", error);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDuplicatePublisherId]);
    return {
        selectedDuplicatePublisher: selectedDuplicatePublisher,
        setSelectedDuplicatePublisher: setSelectedDuplicatePublisher,
        selectedDuplicatePublisherId: selectedDuplicatePublisherId,
        setSelectedDuplicatePublisherId: setSelectedDuplicatePublisherId,
        onClose: onClose,
    };
};
